// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__jmXtJ"};